import {CommandBase} from "./commandBase";
import {BuildingReward, RemoteConstantsModel, TriggerSpec} from "../models/remoteConstants.model";
import {mintNamespacedUid} from "../utils/uid.utils";
import {defaultTriggerSpec} from "../utils/reward.utils";

// Appends a BuildingReward with the chosen trigger (its kind-specific fields at
// their defaults) granting 0 Gold to a building's passiveRewards. `newUid` is
// read back by the view so it can expand the card it just created.
export class AddBuildingPassiveRewardCommand extends CommandBase {
    buildingId: string;
    triggerKind: TriggerSpec['kind'];
    newUid?: string;

    constructor(buildingId: string, triggerKind: TriggerSpec['kind']) {
        super();
        this.buildingId = buildingId;
        this.triggerKind = triggerKind;
    }

    execute(data: RemoteConstantsModel): boolean {
        const building = data.buildings.find(b => b.id === this.buildingId);
        if (!building) return false;

        const reward: BuildingReward = {
            // e.g. "building.city.passivereward.0" — the uid is only an
            // internal per-building state key, but readable beats UUID.
            uid: mintNamespacedUid(building.id, 'passivereward',
                (building.passiveRewards ?? []).map(r => r.uid)),
            active: true,
            trigger: defaultTriggerSpec(this.triggerKind),
            grant: {kind: 'Gold', amount: 0},
            amountIncreasePerTrigger: 0,
        };

        building.passiveRewards = [...(building.passiveRewards ?? []), reward];
        this.newUid = reward.uid;
        return true;
    }
}
